module.exports = __webpack_public_path__ + "static/media/google-play-badge.ce787785.svg";